import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  "class": "dashboard fs_box_wrapper"
};
var _hoisted_2 = {
  "class": "fs_box fs_dashboard_box fs_box_narrow"
};
var _hoisted_3 = {
  "class": "fs_box_header",
  style: {
    "padding": "20px 15px",
    "font-size": "16px"
  }
};
var _hoisted_4 = {
  "class": "fs_box_body fs_padded_20"
};
var _hoisted_5 = {
  key: 0,
  "class": "fs_integration_form"
};
var _hoisted_6 = {
  key: 0,
  "class": "text-align-center"
};
var _hoisted_7 = {
  key: 1,
  "class": "text-align-center"
};
var _hoisted_8 = {
  key: 2,
  "class": "text-align-center"
};
var _hoisted_9 = {
  key: 1,
  style: {
    "color": "red"
  }
};
var _hoisted_10 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  var _component_el_input = _resolveComponent("el-input");
  var _component_el_button = _resolveComponent("el-button");
  var _component_router_link = _resolveComponent("router-link");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_breadcrumb, {
    separator: "/"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_breadcrumb_item, {
        to: {
          name: 'integrations'
        }
      }, {
        "default": _withCtx(function () {
          return _cache[5] || (_cache[5] = [_createTextVNode("API Integrations")]);
        }),
        _: 1 /* STABLE */
      }), $data.integration ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_breadcrumb_item, null, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString($data.integration.provider), 1 /* TEXT */)];
        }),
        _: 1 /* STABLE */
      }), _createVNode(_component_el_breadcrumb_item, null, {
        "default": _withCtx(function () {
          return [_createTextVNode(_toDisplayString($data.integration.title), 1 /* TEXT */)];
        }),
        _: 1 /* STABLE */
      })], 64 /* STABLE_FRAGMENT */)) : (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
        key: 1
      }, {
        "default": _withCtx(function () {
          return _cache[6] || (_cache[6] = [_createTextVNode("View")]);
        }),
        _: 1 /* STABLE */
      }))];
    }),
    _: 1 /* STABLE */
  })]), _createElementVNode("div", _hoisted_4, [!$data.fetching && $data.integration ? (_openBlock(), _createElementBlock("div", _hoisted_5, [!$data.integration.settings.webhook_verified ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[9] || (_cache[9] = _createElementVNode("h3", null, "One more step. Please set the webhook now in ThriveCart", -1 /* HOISTED */)), _createVNode(_component_el_input, {
    modelValue: $data.other_data.webhook_url,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.other_data.webhook_url = $event;
    }),
    readonly: true
  }, null, 8 /* PROPS */, ["modelValue"]), _cache[10] || (_cache[10] = _createElementVNode("p", null, "Please copy the webhook url and set to ThriveCart webhook settings", -1 /* HOISTED */)), _createVNode(_component_el_button, {
    size: "small",
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return $options.fetchIntegration();
    }),
    type: "success"
  }, {
    "default": _withCtx(function () {
      return _cache[7] || (_cache[7] = [_createTextVNode("I have done it")]);
    }),
    _: 1 /* STABLE */
  }), $data.fetch_counter >= 2 ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    onClick: _cache[2] || (_cache[2] = function ($event) {
      return $options.publish();
    }),
    size: "small",
    type: "danger"
  }, {
    "default": _withCtx(function () {
      return _cache[8] || (_cache[8] = [_createTextVNode("Publish Anyway")]);
    }),
    _: 1 /* STABLE */
  })) : _createCommentVNode("v-if", true)])) : $data.integration.status == 'draft' ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_cache[12] || (_cache[12] = _createElementVNode("h3", null, "This API integration is on draft mode.", -1 /* HOISTED */)), _createVNode(_component_el_button, {
    onClick: _cache[3] || (_cache[3] = function ($event) {
      return $options.publish();
    }),
    type: "primary"
  }, {
    "default": _withCtx(function () {
      return _cache[11] || (_cache[11] = [_createTextVNode("Publish this API Integration")]);
    }),
    _: 1 /* STABLE */
  })])) : (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("h3", null, "Your ThriveCart Account (" + _toDisplayString($data.integration.remote_id) + ") is connected", 1 /* TEXT */), $data.other_data && $data.other_data.account ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("p", null, "Connected Account: " + _toDisplayString($data.other_data.account.account_url), 1 /* TEXT */), _cache[13] || (_cache[13] = _createElementVNode("p", null, "Webhook URL: ", -1 /* HOISTED */)), _createVNode(_component_el_input, {
    style: {
      "margin-bottom": "30px"
    },
    modelValue: $data.other_data.webhook_url,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.other_data.webhook_url = $event;
    }),
    readonly: true
  }, null, 8 /* PROPS */, ["modelValue"])], 64 /* STABLE_FRAGMENT */)) : (_openBlock(), _createElementBlock("p", _hoisted_9, "API Validation Failed.")), _createVNode(_component_router_link, {
    "class": "el-button el-button--primary btn_link",
    to: {
      name: 'connectors'
    }
  }, {
    "default": _withCtx(function () {
      return _cache[14] || (_cache[14] = [_createTextVNode("Setup a new Data Connector")]);
    }),
    _: 1 /* STABLE */
  })]))])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_skeleton, {
    rows: 3,
    animated: ""
  })]))])])]);
}